<div class="rx-textarea-wrapper">
	<label [attr.for]="textareaId" hidden>{{ label }}</label>
	<textarea
		#textareaInput
		[formControl]="control"
		[placeholder]="placeholder"
		[attr.id]="textareaId"
		[rows]="rows"
		class="rx-textarea-input"
		(keydown.control.enter)="submit()"
		(keydown.meta.enter)="submit()"
	></textarea>
	<div class="rx-textarea-actions">
		<ng-content select="[rxTextareaSubmit]"></ng-content>
		<ng-content select="[rxTextareaCancel]"></ng-content>
	</div>
</div>
